<template>
    <div>
        <div class=" grid gap-8">
            <div>
                <div class=" font-bold text-16 lg:text-18">{{lbl.crownpoint.content.line1.header}}</div>
                <div class=" text-14 pt-2 lg:text-16" v-html="lbl.crownpoint.content.line1.description"></div>
            </div>
            <div>
                <div class=" font-bold text-16 lg:text-18">{{lbl.crownpoint.content.line2.header}}</div>
                <div class=" text-14 pt-2 lg:text-16" v-html="lbl.crownpoint.content.line2.description"></div>
            </div>
            <div>
                <div class=" font-bold text-16 lg:text-18">{{lbl.crownpoint.content.line3.header}}</div>
                <div class=" text-14 pt-2 lg:text-16" v-html="lbl.crownpoint.content.line3.description"></div>
            </div>
            <div>
                <div class=" font-bold text-16 lg:text-18">{{lbl.crownpoint.content.line4.header}}</div>
                <div class=" text-14 pt-2 lg:text-16" v-html="lbl.crownpoint.content.line4.description"></div>
            </div>
            <div>
                <div class=" font-bold text-16 lg:text-18">{{lbl.crownpoint.content.line5.header}}</div>
                <div class=" text-14 pt-2 lg:text-16" v-html="lbl.crownpoint.content.line5.description"></div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: 'Content',
    mixins: [LocaleMixin],
}
</script>

<style>
</style>
